<template>
  <div
    class="flex xl:items-center xl:justify-between w-full mt-10 md:mt-16 xl:flex-row flex-col items-start"
  >
    <div class="flex items-center gap-3 w-[40%]">
      <NuxtImg
        src="/images/google.webp"
        height="64"
        width="64"
        loading="lazy"
        alt="google icon for ratings"
        format="webp"
      />
      <div class="flex items-start flex-col">
        <div class="flex items-center gap-2">
          <p class="text-lg font-semibold">4.4</p>
          <div class="flex items-center gap-1">
            <template v-for="star in rating">
              <WrSVGIcon :name="star.icon" :class="star.class" />
            </template>
          </div>
        </div>
        <p class="text-base text-[#57586a] leading-[1.8]">
          228+ Google Reviews
        </p>
      </div>
    </div>
    <div class="items-center justify-between w-full py-3 pl-12 lg:flex hidden">
      <template v-for="info in companyInfo">
        <div>
          <h3
            class="text-[#57586a] dark:text-white text-[18px] mt-[3px] min-h-[62px] pl-[15px] pt-[17px] relative z-10 before:content-[''] before:absolute before:top-[0px] before:left-[-18px] before:w-[9px] before:h-[9px] before:rounded-full before:border-[2px] before:border-[#f6a61e] before:block after:content-[''] after:absolute after:bottom-[-1px] after:left-[-10px] after:w-[7px] after:h-[7px] after:bg-[#f6a61e] after:rounded-full after:block"
          >
            <strong
              class="text-[#5540e6] dark:text-white text-[24px] font-[800] relative z-10 before:content-[''] before:absolute before:top-[-17px] before:left-[-15px] before:w-[39px] before:h-[62px] before:bg-[#f0edfd] dark:before:bg-[#5540e6] before:rounded-[26px] before:rotate-[18deg] before:z-[-1]"
            >
              {{ info.heading }}
            </strong>
            <span class="relative z-10 ml-[6px]">{{ info.content }}</span>
          </h3>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { defineAsyncComponent } from "vue";

const rating = ref([
  {
    icon: "WrStarFull",
    class: "w-[26px] h-[19px]",
  },
  {
    icon: "WrStarFull",
    class: "w-[26px] h-[19px]",
  },
  {
    icon: "WrStarFull",
    class: "w-[26px] h-[19px]",
  },
  {
    icon: "WrStarFull",
    class: "w-[26px] h-[19px]",
  },
  {
    icon: "WrStarFull",
    class: "w-[26px] h-[19px]",
  },
  {
    icon: "WrStarHalf",
    class: "w-[26px] h-[19px] half-star",
  },
]);
defineProps({
  companyInfo: {
    type: Array,
    default: [
      {
        heading: "1.1m",
        content: "Line of code",
      },
      {
        heading: "#1",
        content: "in Product Development",
      },
      {
        heading: "100%",
        content: "Client Satisfaction",
      },
    ],
  },
});
</script>

<style scoped>
.half-star {
  --star-bg: #dbdbdb;
  --star-fill: #f6a61e;
}
</style>
